export const VK_CLIENT_ID = 54654314;

let sdkPromise = null;

// Load the provider only when starting or completing VK authentication.
export function initVkConfig() {
  if (!sdkPromise) {
    sdkPromise = import('@vkid/sdk').then(sdk => {
      sdk.Config.init({
        app: VK_CLIENT_ID,
        redirectUrl: window.location.origin,
        responseMode: sdk.ConfigResponseMode.Redirect,
        source: sdk.ConfigSource.LOWCODE,
        scope: '',
      });
      return sdk;
    }).catch(error => { sdkPromise = null; throw error; });
  }
  return sdkPromise;
}

export function sendVkUserToBackend(payload) {
  return fetch('/api/auth/vk', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      access_token: payload.access_token,
    }),
  }).then((r) => r.json().then((d) => {
    if (!r.ok) throw new Error(d.error || 'Ошибка входа через VK');
    return d;
  }));
}
